import React from 'react';

import { useGetList } from '@vlabs/api/artemy/client';
import type { ListId } from '@vlabs/api/artemy/model';
import { QueueIcon } from '@vlabs/icons';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { routes } from '@vlabs/shared/navigation/routes';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import { generatePath } from 'react-router-dom';

import st from './ListItem.module.sass';
import type { BaseDataItemProps } from '../base-data-item';
import { BaseDataItem } from '../base-data-item';

export interface ListItemProps extends Omit<BaseDataItemProps, 'title'> {
  listId?: ListId;
  linkEnabled?: boolean;
}

const displayName = 'ListItem';
const testid = buildTestid(displayName);

export function ListItem({
  listId = undefined,
  actions = undefined,
  className = undefined,
  linkEnabled = true,
  'data-testid': dataTestId = 'list-item',
}: ListItemProps): React.JSX.Element | null {
  // @ts-expect-error не делаем запрос, если listId = undefined
  const getList = useGetList(listId, {
    query: {
      enabled: !!listId,
    },
  });

  if (!listId) return null;

  return (
    <BaseDataItem
      actions={actions}
      className={className}
      title={(
        <React.Fragment>
          <QueueIcon className={st.Icon} />
          {linkEnabled ? (
            <Link
              className={st.Link}
              kind="secondary"
              size="medium"
              to={generatePath(routes.lists.read, { listId })}
            >
              {getList.data?.user_data}
            </Link>
          ) : (
            <span className={st.Link}>
              {getList.data?.user_data}
            </span>
          )}
        </React.Fragment>
      )}
      {...testid(dataTestId)}
    />
  );
}
